var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FF",
    d: "M14.088 3.5A10.719 10.719 0 003.151 14a11.156 11.156 0 0010.937 11.419 11.594 11.594 0 0011.813-11.375c-.154-10.5-9.844-12.185-9.844-12.185s9.91.832 10.719 12.163c.175 7-5.425 13.016-12.688 13.169C6.869 27.366.657 21.569.526 14.066.285 6.519 6.3.13 14.066 0c0 0 1.86 0 1.903 1.837 0 1.75-1.881 1.663-1.881 1.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern0)",
    d: "M1 0h28v28H1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.01563)",
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEQElEQVR4XuVbDW/cIAxNp2g6Tf3/v3SaTlW0TRDMGWMbQ0gu0EpVdb184Pf8jA3mYzn5Z/u7/fOv2PYXPeF94bP/uC7LI/xdf6wfJw8pefwpL8NGP8HQ9QVCHAH+XwBh/TkwAN7wbVmi0YFVYJ81nND9eCzLlV7QxQMSw4FVyrjmAegeJ4UrveAQAKzhVMDEzb03cGCE+x7uO/eLfs70iGYAnPHe1UkwYw00su/uxRJIAmgApTcY1QBkOpfYlCSgsO9ng5WPAfG9i3xNy+xRBYDo8jW6x4GRaN8BUGK4NxBmAFSXTwTLyMKxBoYzNJWM5pj143nu3mABTvIOEwBFt+fcHRndYqDFnXt4QxEAlnkYnRDhJR1bjKq9BpPTkkOoAIjMC1H9SsMpUNvXPivVgqADEB4qztsBiKM6rGVduj7GhYpsUgQAHpalr4T9WsR7GSuCUOkJLACJ7pUk5m7GAyg1cuABANenwQ6BcVfj3ZAjgYakKQPAwv47g51VQtELXHKllNg5AAX2vfEX1+xWo1tmhgSAGPiEfH0k47EUtBI7BQCzT/N7pVBpZeiK+0oBMQKgZnwumFTMrVcYZn0Hrhk46aYAwIrlJOwDSL+/9qU6jsQXADT4IYhHZT/JC0JxRr0gAgAoxbR3kDnfIgUc3D/JDOYByNJelABdvUhpMajlGkkGKQDMys7o7l9Kj3cAJtZ/BACtIOE44AHw7uGRQEvWYRWWaqbF/e5wjxQHXgDg5e0w4tEyPw1oGwAkBsyi/5gP/Nk9Hdu1e0D4giI4HQBMQpRK4Nt6QEBmdg/gCqOXBCbL/7mACFLPYoCUB0wXA1ysI2X9t4kBON23e8BAy1+lZEsHIKSJtBKcKhFy6X5ACWe3cjUYguLnr2ublkpMtn6Py/0MgFgPMO0rMwTCxP2JrPkVoTc2LbUybK0D6J4GvyaIn7Yuy+gVIZ7mqUcny+LSstjIMtDc3/Es7wvgRdGBp0NMKrell+8MQevbBIVRstYpSLm8N4gWSEeLBVH7Sh+ybXcYOkEG2h1K6hslkNv6A3A8GAAEusmrBXG9Q0RYKL1zfwDX2KVJ194jNMCswBlfIkvvEhOKJL+weLOpkdvdtuQvKgDspgneMzzYptor7WWZN547KAIQQYB44P7iHMHQiNTLUO45dK732+AV3mkDgDsKQ+qFktZ6gyB1rtcYn6XCpUH6uZXODCQ4HuncLr0fvpe6WWqNrwbA2w6BkUoBrSWc1TrLGn4wSTNJgDJj7SDH539aW+a9q7vzhsrxnCPyawIAPMEfkZMkwZwhoIcmKChgrAecHr9DNQmcU+rhac0AiHqUzgphyVjFLhzF6WE4DOEwABiIhDXpcBSzA5X1JTBb9Wcdr+0GQAYElze0MH/y0ZvuAGAbo6YhVtB4we1HkvyiNXhasT4VAGkQSbALF51tqDSWtwBgZeeK6/4Da98rbjna+IAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.321dafb8e4be777734b1d5308dc43bc3.svg";
export { ForwardRef as ReactComponent };